import React from 'react';

import MuiPopper, { PopperProps as MuiPopperProps } from '@mui/material/Popper';

/**
 * Пропсы универсального Popper-компонента {@link Popper}.
 * Наследует все стандартные пропсы MUI Popper и требует children.
 */
export interface PopperProps extends MuiPopperProps {
  /**
   * Содержимое, которое будет отображено внутри поповера
   */
  children: React.ReactNode;
}

/**
 * Универсальный Popper-компонент для UI-библиотеки.
 * Обёртка над MUI Popper, принимает все стандартные пропсы Popper и children для отображения содержимого.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри компонента Paper.
 * @returns  Компонент Popper.
 *
 * @example
 *
 * ```
 * <Popper open={open} anchorEl={anchorEl} onClose={handleClose}>
 *   <div>Контент поповера</div>
 * </Popper>
 * ```
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link PopperProps}
 */
export const Popper: React.FC<PopperProps> = ({ children, ...props }) => (
  <MuiPopper {...props}>{children}</MuiPopper>
);
